import styles from "../../PricingTool.module.css";

interface Props { size?: number; light?: boolean }

export default function Spinner({ size = 20, light = false }: Props) {
  const w = Math.max(2, Math.round(size / 8));
  return (
    <div
      className={styles.spinner}
      style={{
        width: size, height: size,
        border: `${w}px solid ${light ? "rgba(255,255,255,0.35)" : "#e6e6ff"}`,
        borderTopColor: light ? "#fff" : "#6B4EFF",
      }}
    />
  );
}
